export default __webpack_public_path__ + "static/media/binance.65ef1f65.png";